import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";
import { authorized, getUserRoles } from "../../utils/authorizationUtils";

import sitePaths from "../../constants/sitePaths";

/**
 * Guard component for authorized routes.
 * Wrap this around route elements inside <Route element={...}>.
 * Usage: <Route path="..." element={<AuthorizedRoute roles={[...]}><Page /></AuthorizedRoute>} />
 */
export default function AuthorizedRoute({ roles, children }) {
  const auth = useAuth();
  const location = useLocation();

  if (auth.isLoading) {
    return <div>Laster inn side...</div>;
  }

  if (auth.isAuthenticated) {
    if (authorized(roles)) {
      return children;
    } else {
      return <UnAuthorized roles={roles} />;
    }
  }

  return <Navigate to={sitePaths.login} state={{ from: location }} replace />;
}

// Keep legacy name as alias for backward compat during migration
const UnAuthorized = ({ roles }) => {
  const userRoles = getUserRoles();
  return (
    <div
      style={{
        margin: "10px 30px",
        display: "flex",
        flexDirection: "column",
        gap: "5px",
      }}
    >
      <h1>Du mangler tilgang til denne siden</h1>
      <p>
        {userRoles.length > 1 ? "Dine roller er: " : "Din rolle er: "}
        <b>{userRoles.join(", ")}</b>
      </p>
      <p>
        {"For å få tilgang til siden trenger du en av følgende roller: "}
        <b>{roles.join(", ")}</b>
      </p>
    </div>
  );
};
